export default {
  // Words
  welcome: 'Welcome',
  welcomeToYourDashboard: 'Welcome To @:branding.appName Dashboard.'
}
